import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Size(props) {
    return (
        <SvgIcon {...props}>
            <path d="M14.999,2.382L1.466,2.386L1.463,2.382L0,2.385v9.549h15L14.999,2.382z M13.678,10.478H1.312v-6.64h2.137 v3.331h1.357V3.838h2.046v3.331h1.298V3.838h2.104v3.331h1.394V3.838h2.04L13.678,10.478z" />
        </SvgIcon>
    );
}

Size.defaultProps = {
    viewBox: '0 0 15 16'
};

export default Size;
